(function () {
  'use strict';

  /**
   * @ngdoc directive
   * @name patient.directive:selectedDiagnoses
   * @restrict EA
   * @element
   *
   * @description
   *
   * @example
     <example module="patient">
       <file name="index.html">
        <selected-keywords></selected-keywords>
       </file>
     </example>
   *
   */
  angular
    .module('utils.keywords')
    .directive('selectedKeywords', selectedKeywords);

  function selectedKeywords() {
    return {
      restrict: 'EA',
      scope: {
        keywords: '=',
        selected: '@'
      },
      templateUrl: 'utils/keywords/selected-keywords-directive.tpl.html',
      replace: false,
      controllerAs: 'skwCtrl',
      controller: 'KeywordsCtrl',
      bindToController: true,
      link: function (scope, element, attrs) {
        /* jshint unused:false */
        /* eslint "no-unused-vars": [2, {"args": "none"}] */
      }
    };
  }
}());
